import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { listMutations } from '@/modules/sklad/ndSklad/store/types';
import { updateTableDataAction } from '@/main/store/actionsFunctions';
import { TABLE_DATA } from '@/main/store/listEditTypes';
import { PageMode } from '@/main/utils/pageMode';

import { NAME as name, CRUMB_LABEL_LIST } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_LIST,
	dropdownList: {
		SkladOzn: [],
		VyrobekndOzn: [],
		ZakaznikSk: [],
	},
	filter: {
		ProvozovnaId: null as number | null,
		FakturaceprofilId: null as number | null,
		SkladOzn: null as number | null,
		VyrobekndOzn: null as string | null,
		NdNr: null as string | null,
		NdText: null as string | null,
		SkladmistoOd: null as string | null,
		SkladmistoDo: null as string | null,
		DodavatelId: null as number | null,
		NullStavPrp: null as boolean | null,
		NdakcePrp: null as boolean | null,
		PcOd: null as number | null,
		PcDo: null as number | null,
		PncOd: null as number | null,
		PncDo: null as number | null,
		NcOd: null as number | null,
		NcDo: null as number | null,
		PncKorekce: null as number | null,
		ZbozidruhOzn: null as string | null,
		RabatSk: null as string | null,
		MimoKusPrp: null as boolean | null,
		VstupDatOd: null as Date | null,
		VstupDatDo: null as Date | null,
		PoslpohybDatOd: null as Date | null,
		PoslpohybDatDo: null as Date | null,
		PoslprijemDatOd: null as Date | null,
		PoslprijemDatDo: null as Date | null,
		StavOd: null as number | null,
		StavDo: null as number | null,
		StavMinOd: null as number | null,
		StavMinDo: null as number | null,
		StavMaxOd: null as number | null,
		StavMaxDo: null as number | null,
		VyrazenDatPrp: null as boolean | null,
		ObratkovostPrp: null as boolean | null,
		ObratkovostDatOd: null as Date | string | null,
		ObratkovostDatDo: null as Date | string | null,
		ObratkovostSPohybemPrp: null as boolean | null,
		ObratkovostObratOd: null as number | null,
		ObratkovostObratDo: null as number | null,
		ObratkovostPrijemPrp: null as boolean | null,
		ObratkovostVydejPrp: null as boolean | null,
		DodavatelIdText: null as number | null,
		ZbozidruhOznText: null as number | null,
		BinCode: null as string | null,
		ExpiryDatOd: null as Date | null,
		ExpiryDatDo: null as Date | null
	},
	tableSetting: {},
	localState: {
		EnabledObratkovost: false as boolean,
	},
	rowDetail: null,
	extraActions: {
		[TABLE_DATA]: ({ commit, dispatch, state }) => {
			const isSelect = state.props.mode === PageMode.SELECT_LIST;
			if (!state.localState.EnabledObratkovost) {
				commit(listMutations.RESET_OBRATKOVOST);
			}
			return updateTableDataAction(
				state, commit, dispatch,
				(isSelect)
					? apiProvider.tableDataSelect(state.filter)
					: apiProvider.tableData(state.filter),
				'table',
			);
		},
	},
	extraGetters: {},
	extraMutations: {
		[listMutations.ZBOZI_DRUH_LIST_MAPPER](state, { data }) {
			state.filter.ZbozidruhOzn = data.value;
			state.filter.ZbozidruhOznText = data.text;
		},
		[listMutations.DODAVATEL_LIST_MAPPER](state, { data }) {
			state.filter.DodavatelId = data.value;
			state.filter.DodavatelIdText = data.text;
		},
		[listMutations.RESET_OBRATKOVOST](state) {
			state.filter.ObratkovostPrp = null;
			state.filter.ObratkovostSPohybemPrp = null;
			state.filter.ObratkovostObratOd = null;
			state.filter.ObratkovostObratDo = null;
			state.filter.ObratkovostPrijemPrp = null;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
